export default {"src":"/_next/static/media/errorPageImage.72de6091.svg","height":122,"width":246,"blurWidth":0,"blurHeight":0};